import { connect } from 'react-redux';

import { DeleteButton } from 'modules/layout';

import { selectItemPending } from '../services/selectors';
import { deleteNewsRequest } from '../services/actions';

export default connect(
    (state, { id }) => ({
        pending: selectItemPending(state, { id }),
    }),
    (dispatch, { id, delayed }) => ({
        handleDelete: () => {
            dispatch(deleteNewsRequest({ id, delayed }));
        },
    }),
)(DeleteButton);
